<template>
  <div
    v-click-outside="closeOptions"
    class="search-bar"
    :class="{ 'products-search-bar': isProductPages }"
  >
    <input
      v-model="searchTerm"
      type="text"
      :placeholder="getPlaceholder()"
      @click="openOptions()"
    />
    <magnifying-glass class="search-icon"></magnifying-glass>
    <div
      v-if="showOptions && filteredItems && filteredItems.length > 0"
      class="options-search-items"
    >
      <div
        v-for="item in filteredItems"
        :key="isForFeeds ? item.originalFeedIndex : item._id"
        class="option-search-item"
        @click="emitSearchToParent(item)"
      >
        <p>{{ item.name || item.feedName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import MagnifyingGlass from "@/assets/svg/magnifying-glass.svg?inline";
import { normalizeString } from "@/utils/stringNormalize";

export default {
  components: {
    MagnifyingGlass,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => [],
    },
    isForFeeds: {
      type: Boolean,
      default: false,
    },
    isProductPages: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchTerm: "",
      showOptions: false,
    };
  },
  computed: {
    filteredItems() {
      if (!this.searchTerm || this.searchTerm.length < 2) return [];

      const normalizedSearchTerm = normalizeString(
        this.searchTerm.toLowerCase()
      );

      return this.items.filter((item) => {
        const itemName = this.isForFeeds
          ? normalizeString(item.feedName?.toLowerCase() || "")
          : normalizeString(item.name?.toLowerCase() || "");

        return itemName.includes(normalizedSearchTerm);
      });
    },
  },
  methods: {
    emitSearchToParent(item) {
      this.searchTerm = "";
      if (this.isForFeeds) {
        this.$emit("search", {
          type: this.type,
          originalFeedIndex: item.originalFeedIndex,
        });
      } else {
        this.$emit("search", { type: this.type, _id: item._id });
      }
    },
    openOptions() {
      this.showOptions = true;
    },
    closeOptions() {
      this.showOptions = false;
    },
    getPlaceholder() {
      return `${this.$t("campaignManager.search")} ${this.type}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar {
  position: relative;
  width: 33%;
  margin: 0 !important;

  input {
    padding: 3px 8px 3px 8px;
    height: 30px;
  }
}
.products-search-bar {
  width: 50%;
}
.search-icon {
  position: absolute;
  right: 8px;
  bottom: 6px;
}
input {
  width: 100%;
  @include input-style;
}
.options-search-items {
  margin-top: 1px;
  border: 1px solid $light-grey;
  border-radius: 4px;
  position: absolute;
  z-index: 1000;
  background: white;
  width: 100%;
}

.option-search-item {
  cursor: pointer;
  @include base-font;
  @include font-smaller;
  color: $light-grey;
  padding: 4px 10px;
  text-align: left;
  &:hover {
    background: $settings-hover;
    color: $dark-grey;
  }
}
</style>
